import React, { memo, ReactNode } from "react";

import Button from "react-bootstrap/Button";

import "./skipLink.scss";

interface SkipLinkProps {
  children: ReactNode;
  target: string;
}

const SkipLink: React.FC<SkipLinkProps> = ({ children, target }) => (
  <Button className="skip-link" href={target}>
    {children}
  </Button>
);

export default memo(SkipLink);
